// extracted by mini-css-extract-plugin
module.exports = {"collectionListContainer":"index_collectionListContainer__96Q_4","collection":"index_collection__28AEH"};